import { Stack } from '@mui/material';
import { type FlowProducedType } from 'flow-schema';
import { omit } from 'lodash';

import { isTruthy } from 'common';

import { SendEmailHtmlViewer } from './HtmlViewer';
import { type OutputContentProps } from '../../../types';
import { DefaultReturnValueContent } from '../../Default/OutputContent';

export function SendEmailNodeOutputContent(props: OutputContentProps<FlowProducedType.SendEmail>) {
  const { returnValue, metadata, isFullHeightView } = props;

  return (
    <Stack spacing={2}>
      {isTruthy(returnValue?.message) && <SendEmailHtmlViewer html={returnValue.message} />}
      <DefaultReturnValueContent
        returnValue={omit(returnValue, 'message')}
        metadata={metadata}
        isFullHeightView={isFullHeightView}
      />
    </Stack>
  );
}
